// Single source of truth for marketplaces that need a crop ratio distinct from ChowNow's
// default 4:3. Adding a new marketplace here propagates to preview cards and download options.
// ChowNow (and Grubhub, which shares 4:3) are handled separately in MarketplacePreviewCards.
export const MARKETPLACE_CROP_CONFIG = [
  {
    integrationName: 'ubereats',
    cssRatio: '5/4',
    outputRatio: '5:4' as const,
    nameKey: 'MarketplacePreviewCards.uberEats',
    cropLabelKey: 'MarketplacePreviewCards.crop54',
    downloadKey: 'SuccessPhotoContent.downloadEdited54',
    filename: 'cropped-5x4.jpg',
  },
  {
    integrationName: 'doordash',
    cssRatio: '1/1',
    outputRatio: '1:1' as const,
    nameKey: 'MarketplacePreviewCards.doorDash',
    cropLabelKey: 'MarketplacePreviewCards.crop11',
    downloadKey: 'SuccessPhotoContent.downloadEdited11',
    filename: 'cropped-1x1.jpg',
  },
  {
    integrationName: 'skip',
    cssRatio: '3/2',
    outputRatio: '3:2' as const,
    nameKey: 'MarketplacePreviewCards.skipTheDishes',
    cropLabelKey: 'MarketplacePreviewCards.crop32',
    downloadKey: 'SuccessPhotoContent.downloadEdited32',
    filename: 'cropped-3x2.jpg',
  },
] as const;

// Integrations that should render MarketplacePreviewCards instead of CroppedImagePreview.
// Grubhub shares 4:3 with ChowNow but modifies the card label, so it belongs here.
// ritual is in INTEGRATION_SIZES but has no config entry here yet, so it still falls
// back to the standard single-image preview.
const DRAWER_INTEGRATION_SET = new Set([
  'grubhub',
  ...MARKETPLACE_CROP_CONFIG.map(c => c.integrationName),
]);

export function hasDrawerIntegration(names?: Set<string>): boolean {
  return [...(names ?? [])].some(name => DRAWER_INTEGRATION_SET.has(name));
}
